<template>
    <CCard>
        <CCardBody>
            <CContainer class="section" fluid>
                <CRow class="border-bottom mb-3">
                    <CCol md="10">
                        <h2 class="section__title my-4">
                            {{ $t("tag_config_general") }}
                        </h2>
                    </CCol>
                </CRow>
                <CRow alignHorizontal="center">
                    <CCol md="12">
                        <CForm
                            ref="formViewTag"
                            @submit="submitForm($event, 'viewTag')"
                        >
                            <CInput
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'viewTag',
                                        fieldName: 'name',
                                    })
                                "
                                v-bind="defaultInputConfig"
                                :value.sync="$v.forms.viewTag.name.$model"
                                :label="$t('name')"
                                :disables="true"
                            />
                            <CInput
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'viewTag',
                                        fieldName: 'code',
                                    })
                                "
                                v-bind="defaultInputConfig"
                                :value.sync="$v.forms.viewTag.code.$model"
                                :label="$t('code')"
                                :disables="true"
                            />
                        </CForm>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <CCardFooter class="d-flex">
            <ButtonSave
                color="success"
                @click="executeSubmitForm('formViewTag')"
                :disabled="forms.viewTag._loading"
            />
            <ButtonBack class="mr-3" title="Go back" />
        </CCardFooter>
    </CCard>
</template>

<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import ButtonLoading from "~/components/ButtonLoading.vue";
import ButtonSave from "~/components/ButtonSave.vue";

/** Mixins */
import formMixin from "~/mixins/form";
import { validationMixin } from "vuelidate";

/** Others */
import { required } from "vuelidate/lib/validators";
import { cilPencil, cilCaretBottom, cilCaretTop, cilSave } from "@coreui/icons";

export default {
    name: "GeneralTab",
    mixins: [formMixin, validationMixin],
    icons: {
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilSave,
    },

    components: {
        ButtonBack,
        ButtonLoading,
        ButtonSave
    },

    props: {
        tagUuid: {
            required,
        },
        mode: {
            required,
        },
        loading: Boolean,
    },

    data() {
        return {
            forms: {
                viewTag: {
                    name: null,
                    code: null,
                    _loading: false,
                    _matchResponse: "_items",
                },
            },
        };
    },
    watch: {
        "forms.viewTag._loading": {
            handler: async function (newValue) {
                this.$emit("update:loading", newValue);
            },
            deep: true,
        },
    },
    validations: {
        forms: {
            viewTag: {
                name: {
                    required,
                },
                code: {
                    required,
                },
            },
        },
    },
    methods: {
        async addTag() {
            await this.sendForm({
                formName: "viewTag",
                url: "/tags",
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
            });
        },
        async updateTag() {
            await this.sendForm({
                formName: "viewTag",
                method: "PUT",
                url: "/tags/" + this.tagUuid,
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
            });
        },
        async submitForm(e, formName) {
            e.preventDefault();
            if (this.mode === "edit") {
                await this.updateTag();
            } else {
                await this.addTag();
            }
            this.$router.go(-1);
        },
    },
    async mounted() {
        if (this.mode == "edit") {
            await this.updateForm({
                formName: "viewTag",
                url: "tags/" + this.tagUuid,
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
            });
        }
    },
};
</script>

<style>
</style>